import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
} from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

interface FirstTimeUserProps {
  onCreateCompany: () => void;
}

const FirstTimeUser: React.FC<FirstTimeUserProps> = ({ onCreateCompany }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 2, sm: 3 },
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="sm">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          textAlign="center"
        >
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2.5, sm: 4 },
              width: '100%',
            }}
          >
            <BusinessIcon
              sx={{
                fontSize: { xs: 40, sm: 60 },
                color: 'primary.main',
                mb: 2,
              }}
            />

            <Typography variant="h4" component="h1" gutterBottom>
              Ласкаво просимо до NSTA CRM
            </Typography>

            <Typography variant="body1" color="text.secondary" paragraph>
              Почніть зі створення вашої першої компанії. Ви зможете керувати
              запасами, відстежувати продажі та контактами в одному місці.
            </Typography>

            <Button
              variant="contained"
              onClick={onCreateCompany}
              sx={{ mt: 2 }}
            >
              Створити компанію
            </Button>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default FirstTimeUser;